import { render } from "./QuizPage.vue?vue&type=template&id=14e6e8bc&scoped=true"
import script from "./QuizPage.vue?vue&type=script&lang=js"
export * from "./QuizPage.vue?vue&type=script&lang=js"

import "./QuizPage.vue?vue&type=style&index=0&id=14e6e8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e6e8bc"]])

export default __exports__